import { useEffect, ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import useFetchWireTransaction from '@/hooks/useApi/useFetchWireTransaction';
import WireTransactionInfo from './WireTransactionInfo';
import { useUserSettingsProvider } from '@/providers/UserSettings.provider';
import { useBlockingLoader } from 'shared';
import { useAlertDialog } from '@/providers/AlertDialog.provider';

type WireTransactionContainerProps = {
  TransactionID: string;
} & Omit<ComponentProps<typeof WireTransactionInfo>, 'transaction'>;

export default function WireTransactionContainer({
  TransactionID,
  Notes,
  jwt,
  ELinxRequestID = '',
  ...props
}: WireTransactionContainerProps) {
  const { userSettings } = useUserSettingsProvider();
  const blockingLoader = useBlockingLoader();
  const alertDialog = useAlertDialog();
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  const { wireTransaction, fetchWireTransaction } = useFetchWireTransaction({
    bearer: jwt,
  });

  useEffect(() => {
    blockingLoader.show();

    fetchWireTransaction({ TransactionID, Timezone: userSettings.timezone })
      .catch((error) => {
        // Not returned: the dialog's promise settles on dismissal, and the loader must drop before that.
        alertDialog.error(tGlobal('error'), error instanceof Error ? error.message : tGlobal('errorOccurred'));
      })
      .finally(() => blockingLoader.hide());
  }, [TransactionID]);

  return (
    <div>
      {wireTransaction && (
        <WireTransactionInfo
          transaction={wireTransaction}
          Notes={Notes}
          jwt={jwt}
          ELinxRequestID={ELinxRequestID}
          {...props}
        />
      )}
    </div>
  );
}
